<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M10.5 0.75C13.1234 0.75 15.25 2.87665 15.25 5.5C15.25 8.12335 13.1234 10.25 10.5 10.25H9.5V12H7.5V13.5H5.75V15H1V11.25L5.92383 6.77344C5.81127 6.36808 5.75 5.94122 5.75 5.5C5.75 2.87665 7.87665 0.75 10.5 0.75ZM10.5 2.25C8.70507 2.25 7.25 3.70507 7.25 5.5C7.25 5.80162 7.2918 6.09355 7.36914 6.37207L7.61621 7.26172L6.93262 7.88379L2.5 11.9131V13.5H4.25V12H6V10.5H8V8.75H10.5C12.2949 8.75 13.75 7.29493 13.75 5.5C13.75 3.70507 12.2949 2.25 10.5 2.25ZM10.5 4.25C11.1904 4.25 11.75 4.80964 11.75 5.5C11.75 6.19036 11.1904 6.75 10.5 6.75C9.80964 6.75 9.25 6.19036 9.25 5.5C9.25 4.80964 9.80964 4.25 10.5 4.25Z"
    fill="currentColor"
  />
</svg>
